export default __webpack_public_path__ + "static/insta-4531b60f7322b653a27d9598f0a5d7ef.png";